














































































import {Component, Prop, Provide} from 'vue-property-decorator';
import Vue from 'vue';
import User from '@/Types/User';
import AppLayout from '@/Layouts/AppLayout.vue';
import trimErrorKeys from '@/utils/trimErrorKeys';

@Component({
    components: {
        AppLayout
    }
})
export default class UserForm extends Vue {
    @Prop({type: Object, required: true}) user!: User
    @Prop({type: Array, required: false, default: undefined}) roles?: string[]
    @Prop({type: Object, required: false, default: () => {}}) errors!: Record<string, string>

    @Provide() _user: User = {...this.user}

    get fieldErrors(): {} {
        return trimErrorKeys(this.errors, 'user.');
    }

    get title(): string {
        return `${this.$data._user.id ? 'Update' : 'Add' } User`;
    }

    get passwordHelp(): string {
        return this.$data._user.id ? 'Leave blank to keep current password' : '';
    }

    async handleDelete(): Promise<void> {
        const {isConfirmed} = await this.$swal.fire({
            title: 'Delete user?',
            text: 'The user and all their data will be removed.  This action is not reversible!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Delete user',
        })

        if (isConfirmed) {
            const url = this.route('admin--user--delete', {'userId': this.$data._user.id});

            this.$inertia.delete(url);
        }
    }

    async handleSubmit(user: User): Promise<void> {
        const url: string = this.route('admin--user--update');
        this.$inertia.post(url, {
            user,
        }, {
            preserveState: (page: { props: any }) => {
                return Object.keys(page.props.errors).length > 0
            },
        });
    }
}
